export enum WorkOrganizationEnum {
  Shifts = 1, //Smjenski rad
  Regular = 2, //Redovan rad
  Halfday = 3, //Poludnevni rad
}
